<h2 mat-dialog-title>Edit Selected Phone Numbers</h2>
<mat-dialog-content class="mat-typography">
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">
      Error occurred
    </div>

    <app-mat-text-input [formControl]="getFormControl('cnam')" label="Caller ID" name="cnam" [submitted]="submitted"
                      explanation="Enter your preferred Company Caller ID Name exactly the way you want it to appear on Caller ID displays, for local calls made from your local TeleGo phone numbers."
                      infoText="You can enter up to 15 characters (including spaces)."
    ></app-mat-text-input>

    <div class="alert alert-warning" role="alert">
      If the Caller ID Name field is already populated with the correct Caller ID Name but not showing an accurate CNAM 14 days after the request was submitted,
      contact support&#64;telego.net for assistance and provide Date and Time when the request was submitted or resubmitted.
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">Cancel</button>
  <button mat-button color="primary" cdkFocusInitial (click)="onSubmit()" [promiseBtn]="buttonSubmitPromise">Submit</button>
</mat-dialog-actions>
